(function($) {
    /* Remix Landing page top carousel */
    window.remixLandingCarouselInit = function() {
        var $carousel_thumbs_wrapper = $('.wcs-carousel-thumbs-wrapper'),
            $carousel_wrapper = $('.wcs-carousel-wrapper'),
            $carousel_thumbs = $carousel_wrapper.find('.wcs-carousel-thumbs'),
            $carousel_thumbs_slide = $carousel_thumbs.find('div.wcs-h-slide'),
            $carousel_image = $carousel_wrapper.find('.wcs-carousel-images li');

        $carousel_thumbs_slide.off('click').on('click', function() {
            var $this = $(this);
            var this_index = $this.index();
            if (!$this.is('.wcs-selected')) {
                $carousel_thumbs_slide.removeClass('wcs-selected').eq(this_index).addClass('wcs-selected');
                $carousel_image.fadeOut('slow').eq(this_index).fadeIn('slow');
            }
        });
        if ($carousel_thumbs_slide.length > 7) {
            $carousel_thumbs.bxSlider({
                slideWidth: 137,
                maxSlides: 6,
                slideMargin: 12,
                infiniteLoop: false,
                pager: false,
                hideControlOnEnd: true
            });
        } else {
            $carousel_thumbs_wrapper.addClass('wcs-no-padding');
        }
    };

    window.remix_bxSlider = function() {
        var $wcsBxSlider = $('ul.wcs-bxslider');
        var sliderElements = $wcsBxSlider.children('li');
        function loadRemixSliderImages(index) {
            var sliderElement = sliderElements.eq(index);
            if (!sliderElement.data('imagesloaded')) {
                sliderElement.find('img').each(function() {
                    var $this = $(this);
                    if (!$this.attr('src'))
                        $this.attr('src', $this.data('src'));
                });
                sliderElement.data('imagesloaded', '1');
            }
        }
        loadRemixSliderImages(0);
        loadRemixSliderImages(1);
        $wcsBxSlider.bxSlider({
            pager: false,
            infiniteLoop: false,
            hideControlOnEnd: true,
            onSlideAfter: function($slideElement, oldIndex, newIndex) {
                var modelNumber = $slideElement.find('.modelCode').val();
                $('.wcs-fr-desc').addClass('wcs-hide');
                $(".wcs-fr-desc[data-modelcode='" + modelNumber + "']").removeClass('wcs-hide');
            },
            onSlideBefore: function($slideElement, oldIndex, newIndex) {
                loadRemixSliderImages(newIndex + 1);
            },
            onSliderLoad: function(currentIndex) {
                $("#wcs_start_witha_insp").addClass("wcs-hide");
            }
        });
    };

    /* Remix Product configurator top carousel */
    window.remixProductConfiguratorInit = function() {
        $('.wcs-remix-config-bxslider').find('ul').bxSlider({
            pager: false,
            infiniteLoop: false,
            hideControlOnEnd: true
        });
    };

    window.designer_sliderInit = function() {
        // Remove if any empty slides exists
        fromOurDesignerCarouselCleanup();

        var designer_slider = $('div.wcs-h-slider');
        if (designer_slider.length === 0)
            return;

        designer_slider.find('img').each(function() {
            var $this = $(this);
            if (!$this.attr('src'))
                $this.attr('src', $this.data('src'));
        });

        var from_our_designer_wrapper = $('.wcs-h-slider-wrapper'),
            designer_carousel_link = $('.wcs-designer-caroulsel-link');
        from_our_designer_wrapper.removeClass('wcs-opacity0');

        var toggle_from_our_designer_carousel = function(obj) {
            $(obj).find('.wcs-arrow').toggleClass('wcs-up');
            from_our_designer_wrapper.slideToggle();
        };
        from_our_designer_wrapper.addClass('wcs-pre-opened');

        designer_carousel_link.click(function(e) {
            e.preventDefault();
            toggle_from_our_designer_carousel($(this));
        });

        var timeout = 5000;
        var wcsConfigDivopentimeValue = $('#wcs-config-divopentime').val();
        if (wcsConfigDivopentimeValue) {
            timeout = parseInt(wcsConfigDivopentimeValue);
        }

        from_our_designer_wrapper.on('mouseover', function(){
        	$(this).addClass('wcs-mouseover');
        });
        
        var timedout = false;
    	setTimeout(function() {
    		if(!from_our_designer_wrapper.hasClass('wcs-mouseover')){
    			toggle_from_our_designer_carousel(designer_carousel_link);
    			from_our_designer_wrapper.removeClass('wcs-pre-opened');
    		}
    		timedout = true;
        }, timeout);
    	
    	from_our_designer_wrapper.on('mouseleave', function(){
    		from_our_designer_wrapper.removeClass('wcs-mouseover');
        	if(from_our_designer_wrapper.hasClass('wcs-pre-opened') && timedout === true){
        		toggle_from_our_designer_carousel(designer_carousel_link);
        		from_our_designer_wrapper.removeClass('wcs-pre-opened');
        	}
        });
              
        designer_slider.bxSlider({
            slideWidth: 231,
            slideHeight: 151,
            maxSlides: 4,
            slideMargin: 2,
            infiniteLoop: false,
            pager: false,
            hideControlOnEnd: true,
            onSliderLoad: function() {
                var $sliderContainer = $('#wcs_from_our_designer_slider');
                if ($sliderContainer.find('.wcs-h-slide').length < 4) {
                    $sliderContainer.find('.bx-wrapper').css({
                        width: '920px',
                        maxWidth: '930px'
                    });
                }
            }
        });
    };


    window.initNewsletterFormValidation = function() {
        var newsletterForm = $('form[name="wcs_newsletter_signup_form"]');
        if (newsletterForm.length === 0)
            return false;

        var newsletterEmail = newsletterForm.find('input.mailgun-email');
        var rx = new RegExp(newsletterEmail.attr('pattern'));
        var agreeElement = newsletterForm.find('input#agreeConcent');

        var cachedRow = newsletterEmail.parents('.wcs-row');
        var cachedErrorElement = cachedRow.find('span.wcs-error-message');
        var cachedButton = newsletterForm.find('input:submit:visible');
        window.setTimeout(function() {
            var error_margin = newsletterForm.find('label.wcs-newsletter-heading').width() + 45;
            newsletterForm.find('.wcs-error-message.wcs-newsletter-error').css('margin-left', error_margin);
        }, 1000);
        window.newsletterFormValidate = function() {
            window.setTimeout(function() {
                if (rx.test(newsletterEmail[0].value)) {
                    newsletterEmail.removeAttr('style').removeClass('ui-state-error').addClass('ui-state-valid');
                    cachedRow.removeAttr('style');
                    cachedErrorElement.removeClass('wcs-show');
                    if (agreeElement[0].checked) {
                        cachedButton.removeClass("wcs-btn-disable").attr('disabled', false);
                    }
                } else {
                    cachedButton.addClass("wcs-btn-disable").attr('disabled', true);
                }
            }, 50);
        };

        newsletterEmail.bind('input propertychange', function() {
            newsletterFormValidate();
        });

        window.newsletterFormValidateIE = function(e) {
            if (e.propertyName.toLowerCase() == "value") {
                newsletterFormValidate();
            }
        };

        var $wcsErrorNewsletterCheck = newsletterForm.find('.wcs-error-newsletter-check');
        agreeElement.bind('change', function() {
            if (this.checked) {
                $wcsErrorNewsletterCheck.removeClass('wcs-show');
            } else {
                $wcsErrorNewsletterCheck.addClass('wcs-show');
            }
        });
        $wcsErrorNewsletterCheck.removeClass('wcs-show').addClass('wcs-hide');
    };

    window.cancelPrintUpsLabel = function() {
        $('#wcs-print_UPS_label').find('.wcs-print-cancel').off('click').on('click', function() {
            $(this).parents('.wcs-print-preview-wrapper').children('span.wcs-close-btn').trigger('click');
        });
    };

    window.remixLandingTabs = function() {
        var $wcsTabTitle = $(".wcs-remix-and-match").find(".wcs-tab-title");
        $wcsTabTitle.on("click", function(e) {
            e.preventDefault();
            var $currentTabHanlder = $(this);
            var curentTab = $currentTabHanlder.data("tabid");
            if (!$currentTabHanlder.hasClass("wcs-active-tab")) {
                $wcsTabTitle.removeClass("wcs-active-tab");
                $currentTabHanlder.addClass("wcs-active-tab");

                if (curentTab === "wcs_start_witha_classic") {
                    $("#wcs_start_witha_insp").addClass("wcs-hide");
                } else {
                    $("#wcs_start_witha_classic").addClass("wcs-hide");
                }
                $("#" + curentTab).removeClass("wcs-hide");
            }
        });
    };

    window.initVideoLinks = function() {
        $('a[data-attr="wcs-youku-video"]').on('click.video', function(evt) {
            var v = $('#wcs-youku-video');
            v.removeClass('wcs-hidden');
            display_Modal_1('wcs-youku-video');
            v.find('iframe').attr('src', v.find('iframe').data('src') + $(this).data('vid') + '?wmode=tranparent');
            evt.preventDefault();
        });
        $('a[data-attr="wcs-youtube-video"]').on('click.video', function(evt) {
            var v = $('#wcs-youtube-video');
            v.removeClass('wcs-hidden');
            display_Modal_1('wcs-youtube-video');
            v.find('iframe').attr('src', v.find('iframe').data('src') + $(this).data('vid') + '?wmode=tranparent');
            evt.preventDefault();
        });
        var videoContainer=$('#wcs-popup-video');
        $('a[data-attr="wcs-popup-video"]').off('click.video').on('click.video', function(evt) {
            videoContainer.removeClass('wcs-hidden');
            videoContainer.find('iframe').attr('src', $(this).data('iframe-url'));
            display_Modal_1('wcs-popup-video');
            evt.preventDefault();
            evt.stopPropagation();
        });
    };

    $(document).on('click','#wcs-popup-video .wcs-close-btn', function(evt){
        var $popupVideoIframe = $("#wcs-popup-video iframe");
    	var video = $popupVideoIframe.attr("src");
    	$popupVideoIframe.attr("src","");
    	$popupVideoIframe.attr("src",video);
    	
    });
    $(document).on('click','#wcs-youku-video .wcs-close-btn', function(evt){
        var $youkuVideoIframe = $("#wcs-youku-video iframe");
    	var video = $youkuVideoIframe.attr("src");
    	$youkuVideoIframe.attr("src","");
    	$youkuVideoIframe.attr("src",video);
    	
    });
    
    window.fromOurDesignerCarouselCleanup = function() {
        $("#wcs_from_our_designer_slider").find(".wcs-h-slide").each(function() {
            var $this = $(this);
            $this.children().length === 0 && $this.remove();
        });
    };
    
    $(function() {
        sortBy_fn();
        remixLandingCarouselInit();
        remix_bxSlider();
        designer_sliderInit();
        remixProductConfiguratorInit();
        cancelPrintUpsLabel();
        remixLandingTabs();
        initVideoLinks();
        
        if($("#pName").val() == "remixconfigurator") {
            $("#wcs_gw_intro_link").click();
        }
    });
    $(document).on('RemixDeliveryinfoOK', function(){
        window.applePayObj=new ApplePay();
        applePayDesktop.prototype = window.applePayObj;
        applePayDesktop.prototype.constructor = applePayDesktop;
        window.applePayDesktopInst = new applePayDesktop;
        applePayDesktopInst.initialize();
        applePayDesktopInst.preprocess();
    });
    //load more page
    $(document).ready(function(){
        var loadMoreURL = $('#loadMorePage').val();
        btn = $('#loadMore'); // The target for loading more items.
        btn.on('click', function() {
            var $this = $(this);
            var count = $this.data("count") || 0;
            ++count;
            $this.data("count", count);
            var params="&pageNumber=" + count;

            $.ajax({
                type: "POST",
                url: loadMoreURL,
                data: params,
                success: function(response) {
                    $("#loadMorecategories").append(response);
                }
            });
        });
    });

})(jQuery);
